<template>
  <v-container
    fluid
    class="pa-0"
    fill-height
  >
  <div
      v-if="alerta" class="form-error"
    >
        <app-alert
          :text="alerta"
        ></app-alert>
    </div>
    <div
      v-if="error" class="form-error"
    >
        <app-alert
          @dismissed="onDismissed"
          :text="error.message"
        ></app-alert>
    </div>
    <template v-if="$vuetify.breakpoint.xs">
      <div class="curva">
        <img
          class="imgCurva"
          :src="require('@/assets/curvainferior.svg')"
          alt="Apetrus curva"
        />
      </div>
      <v-layout align-space-around justify-space-between column fill-height>
          <v-flex shrink>
            <img
              class="banner"
              :src="require('@/assets/banner.svg')"
              alt="Apetrus banner"
            />
          </v-flex>

          <v-flex class="text-xs-center" shrink>
            <img
              class="logo"
              :src="require('@/assets/logomarca.png')"
              alt="Apetrus logomarca"
            />
          </v-flex>

          <template v-if="!user">
            <v-flex>

              <v-form
                v-if="!user"
                class="form m-auto"
                ref="form"
                v-model="valid"
                lazy-validation
              >
                <v-text-field
                  v-model="login.email"
                  :rules="emailRules"
                  label="E-mail"
                  required
                ></v-text-field>

                <v-text-field
                  v-model="login.password"
                  :rules="passwordRules"
                  label="Senha"
                  type="password"
                  required
                ></v-text-field>

                <v-alert
                  v-model="loginErro"
                  type="error"
                  outline
                >
                  <h4>Atenção!</h4>
                  {{errorMessage}}
                </v-alert>

                <div>
                  <v-btn
                    block
                    round
                    dark
                    :loading="loading"
                    :disabled="loading"
                    color="secondary"
                    class="white--text btnLogin"
                    @click="fazerLogin"
                  >
                    Login
                  </v-btn>
                </div>

              </v-form>
            </v-flex>
          </template>
          <template v-else>
            <v-flex class="text-xs-center">
              <h1>Seguir como: </h1>
              <v-chip color="primary" dark close @input="logout()">
                <v-avatar>
                  <img v-if="user.image" :src="user.image" alt="trevor">
                  <v-icon v-else>account_circle</v-icon>
                </v-avatar>
                {{ user.email }}
              </v-chip>
              <div v-if="!isUserVerified">
                <v-btn flat color="warning" dark @click="resendEmail">Email não verificado! Reenviar.</v-btn>
              </div>
            </v-flex>
            <v-flex class="button-over pa-3">
              <v-layout>
                <v-btn
                  block
                  round
                  :loading="loading"
                  :disabled="loading"
                  color="success"
                  class="white--text btnLogin"
                  @click="$store.dispatch('autenticarLogin')"
                >
                  Continuar
                </v-btn>
              </v-layout>
            </v-flex>
          </template>
      </v-layout>
    </template>
    <template v-if="!$vuetify.breakpoint.xs">
        <div class="onda">
          <img
            class="imgOnda"
            :src="require('@/assets/ondulacao.svg')"
            alt="Apetrus onda"
          />
        </div>

        <v-layout  align-space-around row fill-height>
          <v-flex
            lg4
            md5
            sm5
            class="ml-5 titulo form-flex"
          >
            <v-layout align-space-around justify-space-between column fill-height>

              <v-flex class="text-xs-left pt-3 texto">
                <img
                  class="logo"
                  :src="require('@/assets/logomarca.png')"
                  alt="Apetrus logomarca"
                />
                <div class=" headline blue--text darken-4">
                  {{ !user ? 'Crie conosco' : 'Seja bem-vindo a:' }}
                </div>
                <div
                  style="color:#074d6e"
                  class="font-weight-medium display-1 "
                >
                  {{ !user ? 'Uma nova experiência em abastecimento' : 'Um universo de abastecimento barato' }}
                </div>
              </v-flex>

              <template v-if="!user">
                <v-flex class="text-xs-left">
                  <v-form
                    class="form"
                    ref="form"
                    v-model="valid"
                    lazy-validation
                  >
                    <v-text-field
                      v-model="login.email"
                      :rules="emailRules"
                      label="E-mail"
                      required
                    ></v-text-field>

                    <v-text-field
                      v-model="login.password"
                      :rules="passwordRules"
                      label="Senha"
                      type="password"
                      required
                    ></v-text-field>

                    <v-alert
                      v-model="loginErro"
                      type="error"
                      outline
                    >
                      <h4>Atenção!</h4>
                      {{errorMessage}}
                    </v-alert>

                    <div>

                      <v-btn
                        block
                        round
                        :loading="loading"
                        :disabled="loading"
                        color="secondary"
                        class="white--text btnLogin"
                        @click="fazerLogin()"
                      >
                        Login
                      </v-btn>

                    </div>

                  </v-form>
                </v-flex>
              </template>
              <template v-else>
                <v-flex class="text-xs-left">
                  <h1>Para seguir como: </h1>
                  <v-chip color="primary" dark close @input="logout()">
                    <v-avatar>
                      <img v-if="user.image" :src="user.image" alt="trevor">
                      <v-icon v-else>account_circle</v-icon>
                    </v-avatar>
                    {{ user.email }}
                  </v-chip>
                  <div v-if="!isUserVerified">
                    <v-btn flat color="warning" dark @click="resendEmail">Email não verificado! Reenviar.</v-btn>
                  </div>
                </v-flex>
                <v-flex v-if="!verificarLocalStorage">
                  <v-stepper
                    v-model="stepSMS"
                    vertical
                    style="margin-top: -5em"
                  >
                    <h3 class="mt-3 mx-3">Autenticação de dois fatores</h3>
                    <v-divider class="mt-3"></v-divider>
                    <v-stepper-step
                      :complete="stepSMS > 1"
                      step="1"
                    >
                    Autentique o número de telefone usado em seu cadastro
                    </v-stepper-step>
                    <v-stepper-content step="1">
                      <v-form v-model="valid" ref="form" lazy-validation>
                        <v-layout row wrap>
                          <v-flex xs12 id="captcha-container" class="pa-0"></v-flex>
                        </v-layout>
                      </v-form>
                      <v-btn
                        color="primary"
                        @click="continuarTela()"
                      >
                        Enviar SMS
                      </v-btn>
                    </v-stepper-content>

                    <v-stepper-step
                      :complete="stepSMS > 2"
                      step="2"
                    >
                    Um SMS foi enviado ao seu dispositivo
                    </v-stepper-step>

                    <v-stepper-content step="2">
                      <v-layout row wrap>
                        <v-flex xs12 class="mb-4">
                          <v-text-field
                              v-model="codigoSMS"
                              outline
                              clearable
                              class="centered-input"
                              label="Escreva o código enviado via SMS"
                              mask="#########"
                              hide-details
                          ></v-text-field>
                      </v-flex>
                      </v-layout>
                      <v-btn
                        color="primary"
                        @click="continuarTela()"
                      >
                        Enviar
                      </v-btn>
                    </v-stepper-content>

                  </v-stepper>
                </v-flex>
                <v-flex class="pa-5" v-if="verificarLocalStorage">
                  <v-btn
                    block
                    round
                    :loading="loading"
                    :disabled="loading"
                    color="success"
                    class="white--text btnLogin"
                    @click="$store.dispatch('autenticarLogin')"
                  >
                    Continuar
                  </v-btn>
                </v-flex>
              </template>
            </v-layout>
          </v-flex>

          <v-flex
            lg8
            md7
            sm7
            class="tablet pa-5"
            justify-center
            align-center
          >
            <v-layout
              align-center
              justify-end
              row
            >
              <img
                align-self-center
                class="imgTablet"
                :src="require('@/assets/smartphone.svg')"
                alt="Apetrus tablet"
              />
            </v-layout>
          </v-flex>
        </v-layout>
    </template>
  </v-container>
</template>

<script>

export default {
  data: () => ({
    verificarLocalStorage: false,
    codigoSMS: '',
    stepSMS: 1,
    statusSMS: false,
    loginErro: false,
    errorMessage: '',
    valid: true,
    alerta: '',
    login: {
      email: '',
      password: '',
      tipo: ''
    },
    emailRules: [
      v => !!v || 'Insira seu E-mail!'
    ],
    passwordRules: [
      v => !!v || 'Insira sua senha!'
    ]
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    user () {
      return this.$store.getters.user
    },
    error () {
      return this.$store.getters.error
    },
    isUserVerified () {
      return this.$store.getters.isUserVerified
    },
    pessoa () {
      return this.$store.getters.pessoa
    }
  },
  mounted () {
    if (localStorage.getItem(`${this.user ? this.user.id : undefined}/dispositivoAutenticado`) || (this.pessoa && !this.pessoa.autenticacao)) {
        this.verificarLocalStorage = true
    }
  },
  watch: {
    user (value) {
      if (value !== null && value !== undefined && value.pessoa) {
        this.$router.push('/home')
      }
      if (value) {
        if (localStorage.getItem(`${this.user ? this.user.id : undefined}/dispositivoAutenticado`) || (this.pessoa && !this.pessoa.autenticacao)) {
            this.verificarLocalStorage = true
        }
      }
    },
    verificarLocalStorage () {
      if (localStorage.getItem(`${this.user ? this.user.id : undefined}/dispositivoAutenticado`) || (this.pessoa && !this.pessoa.autenticacao)) {
        this.verificarLocalStorage = true
      } else {
        this.verificarLocalStorage = false
      }
    },
    pessoa (val) {
      if (val && !val.autenticacao) {
        this.verificarLocalStorage = true
      }
    }
  },
  methods: {
    onDismissed () {
      this.$store.dispatch('clearError')
    },
    fazerLogin () {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('signUserIn', { email: this.login.email, password: this.login.password })
      }
    },
    logout () {
      this.$store.dispatch('signUserOut')
    },
    resendEmail () {
      this.$store.dispatch('sendVerifyEmail')
    },
    activeAlert (text) {
        this.alerta = text
        const interval = setInterval(() => {
            this.alerta = undefined
            clearInterval(interval)
        }, 5000)
    },
    continuarTela () {
      switch (this.stepSMS) {
        case 1:
          this.$store.dispatch('sendSmsVerification', 'captcha-container').then(() => {
            this.stepSMS += 1
          }).catch((error) => {
            if (error.code === 'auth/too-many-requests') {
              this.activeAlert('Desculpe! Você está bloqueado por excesso de tentativas. Tente novamente mais tarde.')
            } else if (error.code === 'auth/invalid-phone-number') {
              this.activeAlert('Desculpe! O número de telefone em seu cadastro foi registrado em um formato inválido.')
            } else if (error.code === 'auth/missing-phone-number') {
              this.activeAlert('Desculpe! Você não tem um número registrado em seu cadastro.')
            } else if (error.code === 'auth/unverified-email') {
              this.activeAlert('Desculpe! Você precisa fazer a verificação do seu e-mail antes de continuar.')
            } else if (error.code === 'auth/user-disabled') {
              this.activeAlert('Desculpe! Você seu usuário foi desativado.')
            } else this.activeAlert('Desculpe, não foi possível enviar o seu código, tente novamente mais tarde.')
            alert('Algo deu errado')
          })
          break
        case 2:
          this.$store.dispatch('confirmSmsVerification', this.codigoSMS)
          .then(() => {
            this.stepSMS += 1
            this.verificarLocalStorage = true
          })
          .catch((error) => {
            if (error.code === 'auth/user-mismatch') {
              this.activeAlert('Desculpe! A credencial fornecida não corresponder ao usuário.')
            } else if (error.code === 'auth/user-not-found') {
              this.activeAlert('Desculpe! A credencial fornecida não corresponder a nenhum usuário existente.')
            } else if (error.code === 'auth/invalid-credential') {
              this.activeAlert('Desculpe! A credencial do provedor não está mais válida. Atualize a página e tente novamente.')
            } else if (error.code === 'auth/invalid-verification-code') {
              this.activeAlert('Desculpe! Código inválido, tente novamente.')
            } else this.activeAlert('Desculpe, mas não foi possível confirmar seu código, por favor, tente novamente.')
            alert('Código incorreto')
            this.verificarLocalStorage = false
          })
      }
    }
  }
}
</script>
<style>
.banner {
  width: 100%;
}
.logo {
  width: 30%;
}

.form {
  width: 80%;
  z-index: 2;
  position: relative;
}

.m-auto {
  margin: auto;
}

.curva {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.onda {
  width: 100%;
  position: absolute;
  right: 0;
  bottom: 0;
}

.tablet {
  width: 100%;
  z-index: 2;
}

.imgCurva {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
}

.imgOnda {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
}

.imgTablet {
  width: 100%;
}

.cadastro * {
  font-size: 90%;
}

.logopequeno {
  width: 7%;
}

.form-error {
  z-index: 2;
  position: absolute;
  right: 0;
  top: 0;
  left: 0;
}

.form-flex:first-child,
.form-error:first-child,
.button-over {
  z-index: 2;
}

@media screen and (min-width: 601px) {
  .imgOnda {
    width: 100%;
  }
}
</style>
